import { IDebtorChange } from "../Interfaces";

export const initialState: IDebtorChange = {
    debtorDrawer: {
      title: "",
      visible: false
    },
};